// utils/BreadcrumbConfig.ts
export interface IBreadcrumbRoute {
  name: string;
  path: string;
  dynamic?: boolean;
  parent?: string;
}

export const breadcrumbRoutes: IBreadcrumbRoute[] = [
  // Platform Admin Routes
  { path: '/platform-admin', name: 'Platform Admin' },
  { path: '/platform-admin/groups', name: 'Groups', parent: '/platform-admin' },
  { path: '/platform-admin/services', name: 'Services', parent: '/platform-admin' },
  { path: '/platform-admin/members', name: 'Members', parent: '/platform-admin' },
  { path: '/platform-admin/roles', name: 'Roles', parent: '/platform-admin' },
  {
    path: '/platform-admin/contact-submissions',
    name: 'Contact Submissions',
    parent: '/platform-admin'
  },

  // Profile Routes
  { path: '/profile-settings', name: 'Profile Settings' },
  { path: '/profile-settings/services', name: 'Services', parent: '/profile-settings' },
  { path: '/Users-SocialProfile', name: 'Social Profile' },

  // Main Profile Routes
  { path: '/profile', name: 'Profile' },
  { path: '/profile/user-info', name: 'User Info', parent: '/profile' },
  { path: '/profile/managers', name: 'Managers', parent: '/profile' },
  { path: '/profile/workers', name: 'Workers', parent: '/profile' },
  { path: '/profile/support-workers', name: 'Support Workers', parent: '/profile' },
  { path: '/profile/weekly-patients-schedule', name: 'Weekly Schedule', parent: '/profile' },
  { path: '/profile/ShiftNotes', name: 'Shift Notes', parent: '/profile' },
  { path: '/profile/office-support', name: 'Office Support', parent: '/profile' },
  { path: '/profile/Messages', name: 'Messages', parent: '/profile' },
  { path: '/profile/report-all', name: 'Reports', parent: '/profile' },

  // Payroll Routes
  { path: '/payroll', name: 'Payroll' },
  { path: '/payroll/people', name: 'People', parent: '/payroll' },
  { path: '/payroll/documents', name: 'Documents', parent: '/payroll' },
  { path: '/payroll/onboarding', name: 'Onboarding', parent: '/payroll' },

  // NDIS Operations
  { path: '/ndis-operations', name: 'NDIS Operations' },
  { path: '/ndis-operations/people-culture', name: 'People & Culture', parent: '/ndis-operations' },
  {
    path: '/ndis-operations/corporate-services',
    name: 'Corporate Services',
    parent: '/ndis-operations'
  },
  {
    path: '/ndis-operations/information-technology',
    name: 'Information Technology',
    parent: '/ndis-operations'
  },
  { path: '/ndis-operations/finance', name: 'Finance', parent: '/ndis-operations' },
  {
    path: '/ndis-operations/risk-compliance-governance',
    name: 'Risk & Compliance',
    parent: '/ndis-operations'
  },
  {
    path: '/ndis-operations/marketing-engagement',
    name: 'Marketing & Engagement',
    parent: '/ndis-operations'
  },

  // Task Board
  { path: '/taskboard', name: 'Task Board' },
  { path: '/taskboard/board', name: 'Board', parent: '/taskboard' },
  { path: '/taskboard/Backlogs', name: 'Backlogs', parent: '/taskboard' },

  
  // Forms Routes
  { path: '/feedback-complaints', name: 'Feedback & Complaints' },
  { path: '/maintenance', name: 'Maintenance Request' },
  { path: '/outreach', name: 'Outreach' },
  { path: '/Client-Incident', name: 'Client Incident' },
  { path: '/dataBreach-Incident', name: 'Data Breach Incident' },
  { path: '/employee-IncidentReport', name: 'Employee Incident' },
  { path: '/equipment-IncidentReport', name: 'Equipment Incident' },
  { path: '/medication-IncidentReport', name: 'Medication Incident' },
  { path: '/restrictive-PracticesReport', name: 'Restrictive Practices' },


  // Other Routes
  { path: '/income-expenses', name: 'Income & Expenses' },
  { path: '/Shifts-Details', name: 'Shift Details' },
  { path: '/requested-shifts', name: 'Requested Shifts' },
  { path: '/clockInOut', name: 'Clock In/Out' },
  { path: '/CalenderShifts', name: 'Calendar Shifts' },
  { path: '/membership-management', name: 'Membership Management' },
  { path: '/staff-progress-notes', name: 'Staff Progress Notes' },
  { path: '/humanresources-management', name: 'Human Resources' },
  { path: '/usermanagement', name: 'User Management' },
  { path: '/projectmanagement', name: 'Project Management' },
  {
    path: '/projectmanagement/:id',
    name: 'Project Details',
    dynamic: true,
    parent: '/projectmanagement'
  },
  { path: '/membership-applications-list', name: 'Membership Applications' },
  { path: '/active-user-cards', name: 'Active Users' },
  { path: '/memebership-applications', name: 'Membership Applications' },
  { path: '/InvestmentLending-management', name: 'Investment Lending' },
  { path: '/InvestmentLending-management-Lender', name: 'Investment Lending (Lender)' },
  { path: '/investment-loan-application', name: 'Loan Application' },
  { path: '/ndis-business-tools', name: 'NDIS Business Tools' },
  { path: '/Community-Services', name: 'Community Services' },
  { path: '/ecommerce-services', name: 'E-commerce Services' },
  { path: '/details/:name', name: 'Product Details', dynamic: true },
  { path: '/OnboardingCommunities', name: 'Onboarding Communities' },
  { path: '/services', name: 'Services' }
];
